import {createElement, Component, PropTypes} from 'rlink-react';
import {FormattedMessage} from 'react-intl';
import {ContentImg, ContentDownload} from 'rlink-repos/content-components';
import {NavLink} from 'rlink-router/component';
import navActions from 'rlink-router/actions';
import {FacebookShare, TwitterShare} from 'rlink-social-share/component';

export class MediaGallery extends Component {
  render () {
    let itemsSorted = this.sortMediaItems(this.props.items);
    let itemsParsed = this.renderMediaItems(itemsSorted);

    return (<div>{this.renderRows(itemsParsed)}</div>);
  }

  sortMediaItems (items) {
    return items.sort((a, b) => {
      if (a.row !== b.row) {
        return (a.row - b.row);
      } else {
        return (a.priority - b.priority);
      }
    });
  }

  renderMediaItems (items) {
    let mediaItems = {};
    for (let i = 0; i < items.length; i++) {
      let item = items[i];
      let previousItem = (i === 0) ? items[items.length - 1].slug : items[i - 1].slug;
      let nextItem = (i === items.length - 1) ? items[0].slug : items[i + 1].slug;
      if (!(item.row in mediaItems)) {
        mediaItems[item.row] = [];
      }

      if (item.category === 'wallpaper') {
        mediaItems[item.row].push(<Wallpaper key={`wallpaper${item.row}-${i}`}
          modalOpen={(this.props.modalOpen === item.slug)}
          css={this.props.css}
          fontAwesome={this.props.fontAwesome}
          previousItem={previousItem}
          nextItem={nextItem}
          {... items[i]} />);
      } else if (item.category === 'video') {
        mediaItems[item.row].push(<Video key={`video${item.row}-${i}`}
          modalOpen={(this.props.modalOpen === item.slug)}
          css={this.props.css}
          previousItem={previousItem}
          nextItem={nextItem}
          fontAwesome={this.props.fontAwesome} {... items[i]} />);
      }
    }

    return mediaItems;
  }

  renderRows (items) {
    let mediaRows = [];
    let index = 0;
    for (let row in items) {
      mediaRows.push(
        <div key={`mediaRow-${index}`} className={`${this.props.css['media-row']} ${this.props.css[`fit-${items[row].length}`]}`}>{items[row]}</div>
      );
      index++;
    }

    return mediaRows;
  }
}

export class Wallpaper extends Component {
  componentDidMount () {
    this.determineBestWallpaper();
  }

  determineBestWallpaper () {

    let totalScreenPixels = screen.width + screen.height;
    let bestWallpaperMatches = [];
    let remainingWallpaperMatches = [];
    let allWallpapers = [];
    for (let deviceName in this.props.devices) {
      allWallpapers = allWallpapers.concat(this.props.devices[deviceName]);
    }
    for (let i = 0; i < allWallpapers.length; i++) {
      let wallpaper = allWallpapers[i];
      let downloadHeight = wallpaper.height;
      let downloadWidth = wallpaper.width;
      let totalImagePixels = downloadWidth + downloadHeight;
      let pixelDifference = Math.abs(totalScreenPixels - totalImagePixels);
      let link = wallpaper.imagePath;
      let description = `${downloadWidth} x ${downloadHeight}`;
      if (downloadWidth >= screen.width
        && downloadHeight >= screen.height) {
        bestWallpaperMatches.push({
          pixelDifference,
          link,
          width: downloadWidth,
          height: downloadHeight,
          description,
        });
      } else {
        remainingWallpaperMatches.push({
          pixelDifference,
          link,
          width: downloadWidth,
          height: downloadHeight,
          description,
        });
      }

    }

    if (bestWallpaperMatches.length === 0) {
      bestWallpaperMatches = remainingWallpaperMatches;
    }

    bestWallpaperMatches.sort((a, b) => (a.pixelDifference - b.pixelDifference));

    let bestWallpaper = bestWallpaperMatches[0];

    this.setState({bestWallpaper});
  }

  render () {
    return (
      <div key={`${this.props.thumbnailPath}`}>
        <NavLink href={{
          view: 'media',
          params: {slug: this.props.slug},
        }}>
          <div className={this.props.css.overlay}>
            <ContentImg src={this.props.thumbnailPath} className={`${this.props.css.thumbnail}`} />
          </div>
        </NavLink>
        <div onClick={() => {
            this.setState({allWallpapers: false});
            navActions.NavTo({
              view: 'media',
              params: {slug: ''}});
          }} className={`${this.props.css['modal-overlay']} ${(this.props.modalOpen) ? this.props.css['modal-open'] : ''}`} />
        <div className={`${this.props.css.modal} ${(this.props.modalOpen) ? this.props.css['modal-open'] : ''}`}>
          <ContentImg src={this.props.thumbnailPath} />
          <div className={this.props.css['social-links']}>
            <ul>
              <li>
                <FormattedMessage
                  id="ui.label.title.MEDIA_GALLERY_SHARE"
                  defaultMessage="share"
                  description="Title for the media gallery share options." />
              </li>
              <FacebookShare fontAwesome={this.props.fontAwesome} css={this.props.css} shareUrl={`${(typeof window.location !== 'undefined') ? window.location.origin : ''}/m/${this.props.slug}`} shareText={this.props.title} />
              <TwitterShare fontAwesome={this.props.fontAwesome} css={this.props.css} shareUrl={`${(typeof window.location !== 'undefined') ? window.location.origin : ''}/m/${this.props.slug}`} shareText={this.props.title} />
            </ul>
          </div>

          <div className={`${this.props.css['download-link-container']} ${(this.state && this.state.allWallpapers) ? this.props.css['downloads-active'] : ''}`}>
            <NavLink href={{
              view: 'media',
              params: {slug: this.props.previousItem},
            }}
              className={`${this.props.css['modal-nav-previous']}`}>
              <i className={`${this.props.fontAwesome.fa} ${this.props.fontAwesome['fa-angle-left']}`} />
            </NavLink>
            {this.state && 'bestWallpaper' in this.state && <ContentDownload className={`${this.props.css['download-link']} ${this.props.css.best}`}
              download={this.state.bestWallpaper.link}
              href={this.state.bestWallpaper.link}>
              <FormattedMessage
                id="ui.label.button.MEDIA_GALLERY_DOWNLOAD"
                defaultMessage="Download {RESOLUTION}"
                description="Label for the media download button for wallpapers. {RESOLUTION} gets replaced with the download resolution e.g. 1920 X 1080."
                values={{
                  RESOLUTION: (this.state && 'bestWallpaper' in this.state) ? this.state.bestWallpaper.description : '',
                }} />
              <i className={`${this.props.fontAwesome.fa} ${this.props.fontAwesome['fa-download']} ${this.props.fontAwesome['fa-lg']}`} />
            </ContentDownload>}
        <a onClick={() => this.toggleState('allWallpapers')} className={this.props.css['download-more']} >
          <FormattedMessage
            id="ui.label.button.MEDIA_GALLERY_SHOW_ALL_RESOLUTIONS"
            defaultMessage="show all"
            description="Label for button that shows all available wallpaper download resolutions." />
          <i className={`${this.props.fontAwesome.fa} ${this.props.fontAwesome['fa-navicon']} ${this.props.fontAwesome['fa-lg']}`} />
        </a>
        <NavLink href={{
          view: 'media',
          params: {slug: this.props.nextItem},
        }}
          className={`${this.props.css['modal-nav-next']}`}>
          <i className={`${this.props.fontAwesome.fa} ${this.props.fontAwesome['fa-angle-right']}`} />
        </NavLink>
          </div>
          <div className={`${this.props.css.downloads} ${(this.state && this.state.allWallpapers) ? this.props.css['downloads-active'] : ''}`}>
            <a onClick={() => this.toggleState('allWallpapers')} className={this.props.css['close-downloads']}>&times;</a>

            <div className={this.props.css['device-container']}>
              {this.renderWallpaperLinksByDevice()}
            </div>
          </div>
        </div>
      </div>);
  }

  toggleState (key) {
    let toggleTo = {};
    toggleTo[key] = !((this.state && this.state[key] === true));

    this.setState(toggleTo);
  }

  renderWallpaperLinksByDevice () {
    let links = [];
    for (let deviceName in this.props.devices) {
      if (this.props.devices[deviceName].length > 0) {
      links.push(
        <div key={`${deviceName}-container-${this.props.thumbnailPath}`} className={this.props.css[deviceName]}>
          <h2>{deviceName}</h2>
          <ul>{this.renderWallpaperLinks(this.props.devices[deviceName])}</ul>
        </div>);
    }
    }
    return links;
  }

  renderWallpaperLinks (deviceData) {
    let links = [];
    for (let link in deviceData) {
      if (deviceData[link].imagePath) {
        links.push(
          <li key={`${deviceData[link].imagePath}`} className={this.props.css['wallpaper-download']} data-width={deviceData[link].width} data-height={deviceData[link].height}>
            <ContentDownload href={deviceData[link].imagePath} download={deviceData[link].imagePath}>{deviceData[link].description}</ContentDownload>
          </li>);
      } else {
        console.warn('Missing device image path:', link, deviceData[link]);
      }
    }

    return links;
  }
}

export class Video extends Component {
  render () {
    return (
      <div key={`${this.props.ytid}`}>
        <NavLink href={{
          view: 'media',
          params: {slug: this.props.slug},
        }}>
          <div className={this.props.css.overlay}>
            <span className={this.props.css['ico-play']} />
            <img src={`//img.youtube.com/vi/${this.props.ytid}/0.jpg`} className={this.props.css['media-video']} />
          </div>
        </NavLink>
        <div onClick={() => navActions.NavTo({
          view: 'media',
          params: {},
        })} className={`${this.props.css['modal-overlay']} ${(this.props.modalOpen) ? this.props.css['modal-open'] : ''}`} />
        <div className={`${this.props.css.modal} ${(this.props.modalOpen) ? this.props.css['modal-open'] : ''}`}>
          <NavLink href={{
            view: 'media',
            params: {slug: this.props.previousItem},
          }}
            className={`${this.props.css['modal-nav-previous']}`}>
            <i className={`${this.props.fontAwesome.fa} ${this.props.fontAwesome['fa-angle-left']}`} />
          </NavLink>
          <iframe width="800" height="600" src={`https://www.youtube.com/embed/${this.props.ytid}?rel=0`} frameBorder="0" allowFullScreen />
          <NavLink href={{
            view: 'media',
            params: {slug: this.props.nextItem},
          }}
            className={`${this.props.css['modal-nav-next']}`}>
            <i className={`${this.props.fontAwesome.fa} ${this.props.fontAwesome['fa-angle-right']}`} />
          </NavLink>
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./apps/www.dawnofwar.com/src/components/media-gallery.jsx